/**  @module Apparel/PrintDesign/AddPrintTechnique */
define([
    "dojo/_base/declare",
    "csi/action/Controller",
    "csi/xml"
], function(declare,Controller,xml) {

    return declare(Controller, {

        /**
         * @override
         *
         * Add 1 to print techniques count
         *
         */
        toWriter: function() {
            var rev = this.getParent();
            this.m_writer.changeNode(rev.$URL).changeAttribute("PrintTechniquesCount", xml.ATTR_INTEGER, rev.PrintTechniquesCount + 1);
        },

        /**
         * @override
         *
         * Refresh table
         */
        postProcessSuccess: function() {
            // summary: refresh table
            this.widget.refreshWidget(true);
            this.widget.toolbarNode.enablePlugins();
        }
    });
});